import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { InputGroup, Table } from 'reactstrap';
import Col from 'reactstrap/lib/Col';
import Input from 'reactstrap/lib/Input';
import Row from 'reactstrap/lib/Row';
import { TR } from 'src/TextRes';
import { Booking, BookingOption } from '../../api';
import { SelectInput } from '../cpProfileComponent/CPItemEditComponent';
import FAIcon from '../fAIcon/FAIcon';
import { IThConfig } from '../sortableTh/SortableTh';
import { TableBox } from '../tableBox/TableBox';

interface TableBoxForCPBookingsNewState {
    showMore: boolean[];
}

export interface TableBoxForCPBookingsNewProps {
    listData: Booking[];
    courseBookingOptions: BookingOption[];
    cpVat: string;
    renderTHeadLine: IThConfig[];
    unrejectBooking: (b: Booking) => void;
    rejectBooking: (b: Booking) => void;
    setBookingOption: (b: Booking, bo: BookingOption) => void;
}

export default class TableBoxForCPBookingsNew extends React.PureComponent<
    TableBoxForCPBookingsNewProps,
    TableBoxForCPBookingsNewState
> {
    constructor(props: TableBoxForCPBookingsNewProps) {
        super(props);
        this.state = {
            showMore: [],
        };
    }

    public componentDidMount() {
        const showMoreArray: boolean[] = [];
        this.props.listData.map((b: Booking) => {
            showMoreArray.push(false);
        });
        this.setState({
            showMore: [...showMoreArray],
        });
    }

    public render() {
        const noResultsMessage = TR.tableBoxForCPBookingsNew_no_entries_found;

        if (!this.props.listData || this.props.listData.length < 1) {
            return (
                <legend className="my-3" style={{ color: 'red' }}>
                    {noResultsMessage}
                </legend>
            );
        }

        const renderTHeadLine = (
            <tr>
                {this.props.renderTHeadLine.map((str: IThConfig, index: number) => {
                    return (
                        <th key={str.name + index} style={{ width: str.width }}>
                            {str.name}
                        </th>
                    );
                })}
            </tr>
        );

        return (
            <TableBox
                listData={this.props.listData}
                renderTBodyLine={this.renderTBodyLine}
                renderTHeadLine={renderTHeadLine}
            />
        );
    }

    private renderTBodyLine = (bking: Booking, index: number) => {
        const { showMore } = this.state;
        const { courseBookingOptions } = this.props;

        // console.log(this.props.courseBookingOptions);
        // console.log(bookingOptionArray);

        const newBookingOptionArray: string[] = [];
        courseBookingOptions.map((b: BookingOption) => {
            newBookingOptionArray.push(b.Name);
        });

        return (
            <React.Fragment key={bking.FirstName + bking.LastName + (index + 1)}>
                <tr>
                    <td>
                        <InputGroup>
                            <a
                                onClick={() => {
                                    const showMoreN: boolean[] = showMore;
                                    showMoreN[index] = !showMoreN[index];
                                    this.setState({
                                        showMore: [...showMoreN],
                                    });
                                }}
                                className=" pull-right"
                            >
                                {showMore[index] ? (
                                    <FAIcon mouseHover="Weniger anzeigen" icon="minus-circle" />
                                ) : (
                                    <FAIcon mouseHover="Mehr anzeigen" icon="plus-circle" />
                                )}
                            </a>{' '}
                            &nbsp;{bking.FirstName + ' ' + bking.LastName}
                        </InputGroup>
                    </td>
                    <td>{moment(bking.InsertDate).format('DD.MM.YYYY').toString()}</td>
                    <td>
                        {!bking.Rejected && (
                            <SelectInput
                                bsSize={'sm'}
                                id={`bookingOptions`}
                                name="Buchungsoptions"
                                selectArr={newBookingOptionArray}
                                value={bking.BookingOptionName}
                                onChangeOption={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    this.changeOption(bking, e.target.value);
                                }}
                            />
                        )}
                    </td>
                    <td className="text-right">{this.formatNumber(bking.BookingOptionPrice)} €</td>
                    <td className="text-right">
                        {bking.BookingOptionPrice !== undefined && this.formatNumber(bking.CommissionFee)} €
                    </td>
                    <td>
                        <Input
                            name={`checkbox ${index}`}
                            type="checkbox"
                            checked={bking.Rejected}
                            onChange={() => {
                                if (bking.Rejected) {
                                    this.props.unrejectBooking(bking);
                                } else {
                                    this.props.rejectBooking(bking);
                                }
                            }}
                        />
                    </td>
                </tr>

                {showMore[index] && (
                    <tr>
                        <td colSpan={6}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Adresse</th>
                                        <th>Telefon</th>
                                        <th>E-Mail</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{bking.FirstName + ' ' + bking.LastName}</td>
                                        <td>
                                            {bking.Street && bking.Street !== '' ? (
                                                <>
                                                    {bking.Street}, &nbsp;
                                                    {bking.Zip}
                                                    &nbsp;
                                                    {bking.City}
                                                </>
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td>{bking.Telephone && bking.Telephone !== '' ? bking.Telephone : '-'}</td>
                                        <td>{bking.Email && bking.Email !== '' ? bking.Email : '-'}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className="text-center">
                                            {bking.Note && bking.Note !== '' ? bking.Note : '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                )}
                <>
                    {bking.Rejected && (
                        <tr>
                            <td colSpan={6}>
                                <Row>
                                    <Col md={1}>{TR.tableBoxForCPBookingsNew_reason} </Col>
                                    <Col md={11}>{bking.Reason}</Col>
                                </Row>
                            </td>
                        </tr>
                    )}
                </>
            </React.Fragment>
        );
    };
    private changeOption = (bking: Booking, val: string) => {
        const options = this.props.courseBookingOptions.filter((bo: BookingOption) => bo.Name === val);
        if (options.length > 0) {
            this.props.setBookingOption(bking, options[0]);
        }
    };

    private formatNumber = (n: number) => {
        if (!n) {
            return '';
        }
        return n.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            useGrouping: false,
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/cpBookingRequests/TableBoxForCPBookingsNew.tsx